import { createStorage } from '@aviata/storage';
import type { DebugState } from './types';

const storagePrefix = 'debug-storage:';

/**
 * Storage to keep user's debug state
 */
const initStateStorage = () => {
  const storage = createStorage(localStorage);

  const get = (key: keyof DebugState) => storage.get(`${storagePrefix}${key}`);
  const set = (updatedState: DebugState) => {
    Object.entries(updatedState)
      .filter(([key]) => key !== 'language') // We don't need to save language to storage, since it is handled by appLocale
      .forEach(([key, value]) => {
        storage.set(`${storagePrefix}${key}`, String(value));
      });
  };

  return {
    set,
    get,
  };
};

export const debugEntityLib = {
  initStateStorage,
};
